/**
 * Methods for configuring and managing push notifications from Firebase Cloud
 * Messaging in a ToDesktop application.
 *
 * @remarks
 * This package exposes a number of methods for configuring and managing push
 * notifications from Firebase Cloud Messaging.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
import { setupAddEventListener } from "@todesktop/client-util";
const _pushNotificationsEventMappings = {
    start: "pushNotifications.start",
    error: "pushNotifications.error",
    tokenUpdate: "pushNotifications.tokenUpdate",
    receive: "pushNotifications.receive",
};
/**
 * Starts the push notification service.
 *
 * @param id - Firebase Sender ID
 * @public
 */
export async function start(id, options) {
    return window["todesktop"].pushNotifications.start(id, options);
}
/**
 * @public
 */
export const on = setupAddEventListener(_pushNotificationsEventMappings);
